import React from 'react';
import type { BannerDefinition } from './banner.types';
import { VARIANT_PRIORITY } from './banner.types';

interface BannerContextValue {
  banners: BannerDefinition[];
  dismissedIds: ReadonlySet<string>;
  addBanner: (banner: BannerDefinition) => void;
  removeBanner: (id: string) => void;
  dismissBanner: (id: string) => void;
}

export const BannerContext = React.createContext<BannerContextValue | null>(null);

export function sortByPriority(banners: BannerDefinition[]): BannerDefinition[] {
  return [...banners].sort((a, b) => VARIANT_PRIORITY[a.variant] - VARIANT_PRIORITY[b.variant]);
}

export function selectGlobal(banners: BannerDefinition[]): BannerDefinition[] {
  return sortByPriority(banners.filter((b) => b.scope === 'global'));
}

export function filterByRoute(banners: BannerDefinition[], routePath: string): BannerDefinition[] {
  return banners.filter((b) => Array.isArray(b.scope) && b.scope.some((pattern) => routeMatches(pattern, routePath)));
}

function routeMatches(pattern: string, routePath: string): boolean {
  const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`^${escaped.replace(/:([^/]+)/g, '([^/]+)')}$`);
  return regex.test(routePath);
}
